import { ContextSet } from "./context_set";
import { TokenListObserver } from "@stimulus/mutation-observers";

var Router =
/** @class */
function () {
  function Router(application) {
    this.application = application;
    this.tokenListObserver = new TokenListObserver(this.element, this.controllerAttribute, this);
    this.contextSets = new Map();
  }

  Object.defineProperty(Router.prototype, "configuration", {
    get: function get() {
      return this.application.configuration;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Router.prototype, "element", {
    get: function get() {
      return this.configuration.rootElement;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Router.prototype, "controllerAttribute", {
    get: function get() {
      return this.configuration.controllerAttribute;
    },
    enumerable: true,
    configurable: true
  });

  Router.prototype.start = function () {
    this.tokenListObserver.start();
  };

  Router.prototype.stop = function () {
    this.tokenListObserver.stop();
  };

  Router.prototype.register = function (identifier, controllerConstructor) {
    if (this.contextSets.has(identifier)) {
      throw new Error("Router already has a controller registered with the identifier '" + identifier + "'");
    }

    var contextSet = new ContextSet(this, identifier, controllerConstructor);
    this.contextSets.set(identifier, contextSet);
    this.connectContextSet(contextSet);
  };

  Router.prototype.unregister = function (identifier) {
    var contextSet = this.contextSets.get(identifier);

    if (contextSet) {
      this.disconnectContextSet(contextSet);
      this.contextSets.delete(identifier);
    }
  }; // Token list observer delegate


  Router.prototype.elementMatchedTokenForAttribute = function (element, token, attributeName) {
    this.connectContextForIdentifierToElement(token, element);
  };

  Router.prototype.elementUnmatchedTokenForAttribute = function (element, token, attributeName) {
    this.disconnectContextForIdentifierFromElement(token, element);
  }; // Contexts


  Router.prototype.getContextForElementAndIdentifier = function (element, identifier) {
    var contextSet = this.contextSets.get(identifier);

    if (contextSet) {
      return contextSet.getContextForElement(element);
    }
  };

  Router.prototype.connectContextSet = function (contextSet) {
    var elements = this.tokenListObserver.getElementsMatchingToken(contextSet.identifier);

    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
      var element = elements_1[_i];
      contextSet.connect(element);
    }
  };

  Router.prototype.disconnectContextSet = function (contextSet) {
    var contexts = contextSet.contexts;

    for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
      var element = contexts_1[_i].element;
      contextSet.disconnect(element);
    }
  };

  Router.prototype.connectContextForIdentifierToElement = function (identifier, element) {
    var contextSet = this.contextSets.get(identifier);

    if (contextSet) {
      contextSet.connect(element);
    }
  };

  Router.prototype.disconnectContextForIdentifierFromElement = function (identifier, element) {
    var contextSet = this.contextSets.get(identifier);

    if (contextSet) {
      contextSet.disconnect(element);
    }
  };

  return Router;
}();

export { Router };